import { request } from '@/shared/api/request'

export const getVerificationQR = (params) => {
	return request({ url: '/contract/mgov/user/getQRCode', method: 'GET' })
}
